import DownloadPage from "components/pages/DownloadPage";

/**
 * @function CaptureDownloadDefault
 * @return {React.Component}
 * @exported true
 * @description A capture component in capture group "Download to QuickBooks".
 */
export default function CaptureDownloadDefault(props) {
    return <DownloadPage />;
}